import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "role-permissions";

export const getRolePermissions = (tenantKey: any) => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/${tenantKey}/${apiURL}`, {
				...AuthHeader,
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const getUserRole = (tenantKey: any, user: string) => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/${tenantKey}/${apiURL}/getUserRole`, {
				...AuthHeader,
				params: { user },
			})
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

/** Server-resolved access profile of the caller for this tenant. */
export const getAccessProfile = (tenantKey: any) => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/${tenantKey}/${apiURL}/me`, {
				...AuthHeader,
			})
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const updateRolePermissions = (tenantKey: any, data: any, user: any) => {
	return new Promise((resolve, reject) => {
		axios
			.put(
				`${url}/${tenantKey}/${apiURL}/updateRolePermissions`,
				{ data, user, options: { upsert: true, new: true } },
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error);
			});
	});
};

// CRUD operations for new role permissions schema
export const getRolePermissionsList = (tenantKey: any, params?: any) => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/${tenantKey}/${apiURL}/get`, {
				...AuthHeader,
				params,
			})
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const createRolePermission = (tenantKey: any, data: any) => {
	return new Promise((resolve, reject) => {
		axios
			.post(`${url}/${tenantKey}/${apiURL}/add`, data, AuthHeader)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error || e);
			});
	});
};

export const updateRolePermission = (tenantKey: any, data: any) => {
	return new Promise((resolve, reject) => {
		axios
			.put(`${url}/${tenantKey}/${apiURL}/update`, data, AuthHeader)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error || e);
			});
	});
};

export const deleteRolePermission = (tenantKey: any, id: any) => {
	return new Promise((resolve, reject) => {
		axios
			.delete(`${url}/${tenantKey}/${apiURL}/delete`, {
				params: { id },
				...AuthHeader,
			})
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e?.response?.data?.error || e);
			});
	});
};

export const getUserPermissions = (
	tenantKey: any,
	user: string,
	projectCode?: string
) => {
	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/${tenantKey}/${apiURL}/getUserPermissions`, {
				...AuthHeader,
				params: { user, project_code: projectCode },
			})
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
